module.exports = __webpack_public_path__ + "img/harmonyCity.26bba697.png";